
//**
// 
// 

// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// TODO: Componente Descartado usar usetableInventarioSerie.tsx
// 
// 
// *//


import { AlertSeverityEnum, CategoriaFCorporativaEnum, MaterialTransferido } from "@/shared/interfaces"
import { Box, Checkbox, IconButton, TextField, Tooltip } from "@mui/material"
import { MRT_ColumnDef } from "material-react-table"
import { useCallback, useMemo} from "react"
import DeleteIcon from '@mui/icons-material/Delete';
import { MaterialesKey, useMaterialesUtilizadosStore } from "@/store/erp";
import { texto } from "../utils";
import { useUiStore } from "@/store/ui";
import { CustomAutocompleteArrStringNoForm, CustomTextFieldNoForm } from "../components/ui";
import ButtonSeries from "../components/ui/ButtonSeries/ButtonSeries";
import CustomNumberTextFieldComponent from "../components/ui/CustomNumberTextFiledComponent";

interface ITableColumnsInventarioProps {
  key: MaterialesKey
  handleCargarSeries?: (data: MaterialTransferido) => void
}
export const useTableColumnsInventario = ({ key, handleCargarSeries }: ITableColumnsInventarioProps) => {

  const updateSelectedItemQuantity = useMaterialesUtilizadosStore(s => s.updateSelectedItemQuantity);
  const removeSelectedItem = useMaterialesUtilizadosStore(s => s.removeSelectedItem);
  const setAlert = useUiStore(s => s.setAlert);

  ///* Aumentar cantidad
  const onChangeQuantity = useCallback(
    (value: string | boolean, item: any) => {
      updateSelectedItemQuantity(
        { ...item, cantidad: +value },
        key
      );
    },
    [updateSelectedItemQuantity]
  );

  ///* Aumentar cantidad
  const onChangePrecioUnitario = useCallback(
    (value: string | boolean, item: any) => {
      updateSelectedItemQuantity(
        { ...item, precioUnitario: +value || parseFloat(item.producto_data?.precios?.[0]?.precio || "0") },
        key
      );
    },
    [updateSelectedItemQuantity]
  );

  ///* Aumentar cantidad recibida

  const onChangeQuantityRecibida = useCallback(
    (value: string | boolean, item: any) => {
      updateSelectedItemQuantity(
        { ...item, cantidad_recibida: +value },
        key
      );
    },
    [updateSelectedItemQuantity]
  );

  ///* Validar si contiene series
  /* const onChangeSeries = useCallback(
    (value: boolean, item: any) => {
      updateSelectedItemQuantity(
        {
          ...item, contiene_serie: value,
          series: value ? item.series : []
        },
        key
      );
    },
    [updateSelectedItemQuantity]
  ); */

  ///* Validar si contiene inventariables
  const onChangeExisteInventariable = useCallback(
    (value: boolean, item: any) => {
      updateSelectedItemQuantity(
        {
          ...item, existe: value,
        },
        key
      );
    },
    [updateSelectedItemQuantity]
  );


  const columnsIngresoInventario = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'accion',
      header: 'Acciones',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <Box sx={{ display: 'flex', gap: '1rem' }
          }>
            <Tooltip title="Eliminar" >
              <IconButton
                onClick={
                  () => {
                    removeSelectedItem(row.original.id!, key);
                  }
                }
              >
                <DeleteIcon color="error" />
              </IconButton>
            </Tooltip>
          </Box>
        );
      }
    },
    {
      accessorKey: 'cantidad',
      header: 'Cantidad',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <TextField
            onKeyDown={(event) => {
              if (['e', 'E', '-', '.', ','].includes(event.key)) {
                event.preventDefault();
              }
            }}
            variant="outlined"
            defaultValue={1}
            value={row.original.cantidad?.toString()}
            onChange={e => {
              let currentValue = e.target.value;
              onChangeQuantity(currentValue, {
                ...row.original,
                id: row.original.id,
              });
            }}
            type="number"
            inputProps={{ min: 0, step: 1 }}
          />
        );
      }
    },
    /* {
      accessorKey: 'contiene_series',
      header: 'Contiene series',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {

        const original = row.original

        const {
          contiene_serie,
        } = original

        return row.original.cantidad === 0 || !contiene_serie
          ? (
            <BlockIcon color="error" />
          ) : (
            <Checkbox
              value={contiene_serie}
              inputProps={{ 'aria-label': 'controlled' }
              }
              defaultChecked={contiene_serie}
              onChange={e => {
                onChangeSeries(e.target.checked, {
                  ...original,
                  id: original.id,
                });
              }
              }
            />
          )
      }
    }, */
    {
      accessorKey: 'series',
      header: 'Series',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        const original = row.original

        const {
          contiene_serie
        } = original

        return (
          <ButtonSeries
            disabled={!contiene_serie}
            onClick={() => {
              handleCargarSeries && handleCargarSeries(row.original as any)

            }}
          />
        )
      }
    },
    {
      accessorKey: 'producto_data.codigo',
      header: 'Codigo',
      size: 100,
    },
    {
      accessorKey: 'producto_data.categoria_producto',
      header: 'Categoria',
      size: 150,
    },
    {
      accessorKey: 'producto_data.subcategoria_producto',
      header: 'SubCategoria',
      size: 150,
      Cell: ({ row }) => row.original.producto_data?.subcategoria_producto ?? 'N/A'
    },
    {
      accessorKey: 'producto_data.descripcion',
      header: 'Descripción',
      size: 150,
    },
    {
      accessorKey: 'producto_data.stock_actual',
      header: 'Stock Actual',
      size: 100,
    },



  ], []);

  const columnsSolicitudTrasladoInventario = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'accion',
      header: 'Acciones',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <Box sx={{ display: 'flex', gap: '1rem' }}>

            <Tooltip title="Eliminar">
              <IconButton
                onClick={() => {
                  removeSelectedItem(row.original.id!, key);
                }}
              >
                <DeleteIcon color="error" />
              </IconButton>
            </Tooltip>
          </Box>
        );
      }
    },
    {
      accessorKey: 'cantidad',
      header: 'Cantidad',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <TextField
            variant="outlined"
            defaultValue={1}
            value={row.original.cantidad?.toString()}
            onChange={e => {

              if (!(+e.target.value <= +row.original.producto_data?.stock_actual!))
                return setAlert(true, texto.limite_stock_actual, AlertSeverityEnum.warning);

              onChangeQuantity(e.target.value, {
                ...row.original,
                id: row.original.id,
              });
            }}
            type="number"
            inputProps={{ min: 0, max: row.original.producto_data?.stock_actual, step: 1 }}
          />
        );
      }
    },
    {
      accessorKey: 'producto_data.codigo',
      header: 'Codigo',
      size: 100,
    },
    {
      accessorKey: 'producto_data.categoria_producto',
      header: 'Categoria',
      size: 150,
    },
    {
      accessorKey: 'subcategoria_producto',
      header: 'SubCategoria',
      size: 150,
      Cell: ({ row }) => row.original.producto_data?.subcategoria_producto ?? 'N/A'
    },
    {
      accessorKey: 'producto_data.descripcion',
      header: 'Descripción',
      size: 150,
    },
    {
      accessorKey: 'producto_data.stock_actual',
      header: 'Stock Actual',
      size: 100,
    }
  ], []);

  const columnsItemFactibilidadCorporativaPendiente = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'producto_data.codigo',
      header: 'Codigo',
      size: 100,
    },
    {
      accessorKey: 'producto_data.categoria_producto',
      header: 'Categoria',
      size: 150,
    },
    {
      accessorKey: 'subcategoria_producto',
      header: 'SubCategoria',
      size: 150,
      Cell: ({ row }) => row.original.producto_data?.subcategoria_producto ?? 'N/A'
    },
    {
      accessorKey: 'producto_data.descripcion',
      header: 'Descripción',
      size: 150,
    },
    {
      accessorKey: 'producto_data.stock_actual',
      header: 'Stock Actual',
      size: 100,
    }
  ], []);
  const columnsItemPrecios = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'precioUnitario',
      header: 'Precio Unitario',
      size: 200,
      Cell: ({ row }) => {
        const initial =
          row.original.precioUnitario ??
          row.original.producto_data?.precios?.[0]?.precio ??
          1;

        return (
          <CustomNumberTextFieldComponent
            value={initial}
            onChangeValue={(value) => {
              onChangePrecioUnitario(value, {
                ...row.original,
                id: row.original.id,
              });
            }}
          />
        );
      },
    },

    /* Cell: ({ row }) => {
      return (
        <CustomTextFieldNoForm
          label=""
          variant="outlined"
          defaultValue={row.original.precioUnitario || 1}
          value={row.original.precioUnitario || row.original.producto_data?.precios?.[0]?.precio}
          onChangeCustom={(v) => {
            onChangePrecioUnitario(v.target.value, {
              ...row.original,
              id: row.original.id,
            });
          }}
          type="text"
        />
      )
    } */

    {
      accessorKey: 'precioTotal',
      header: 'Precio Total',
      Cell: ({ row }) => (`$${(parseFloat(row.original?.cantidad?.toString() || "1") || 1) * (parseFloat(row.original?.precioUnitario?.toString() || "0") || parseFloat(row.original.producto_data?.precios?.[0]?.precio || "0") || 0)}`) || '0',
      size: 100,
    },
  ], []);
  const columnsItemFactibilidadCorporativa = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'producto_data.codigo',
      header: 'Codigo',
      Cell: ({ row }) => row.original.producto_data?.codigo ?? 'N/A',
      size: 100,
    },
    {
      accessorKey: 'producto_data.categoria_producto',
      header: 'Categoria',
      Cell: ({ row }) => row.original.producto_data?.categoria_producto ?? 'N/A',
      size: 150,
    },
    {
      accessorKey: 'producto_data.subcategoria_producto',
      header: 'SubCategoria',
      Cell: ({ row }) => row.original.producto_data?.subcategoria_producto ?? 'N/A',
      size: 150,
    },
    {
      accessorKey: 'descripcion',
      header: 'Descripción',
      Cell: ({ row }) => row.original?.descripcion || row.original.producto_data?.descripcion || 'N/A',
      size: 250,
    },
    {
      accessorKey: 'cantidad',
      header: 'Cantidad',
      size: 250,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <TextField
            variant="outlined"
            defaultValue={1}
            value={row.original.cantidad?.toString()}
            onChange={e => {

              onChangeQuantity(e.target.value, {
                ...row.original,
                id: row.original.id,
              });
            }}
            type="number"
            inputProps={{ min: 0, max: row.original.producto_data?.stock_actual, step: 1 }}
            sx={{
              width: '80%',
            }}
          />
        );
      }
    },
    ...columnsItemPrecios,
    /* {
      accessorKey: 'precioUnitario',
      header: 'Precio Unitario',
      size: 100,
      Cell: ({ row }) => {
        return (
          <CustomTextFieldNoForm
            label=""
            variant="outlined"
            defaultValue={row.original.precioUnitario || 1}
            value={row.original.precioUnitario || row.original.producto_data?.precios?.[0]?.precio}
            onChangeCustom={(v) => {
              onChangePrecioUnitario(v.target.value, {
                ...row.original,
                id: row.original.id,
              });
            }}
            type="text"
          />
        )
      }
    }, */
    /* {
      accessorKey: 'precioTotal',
      header: 'Precio Total',
      Cell: ({ row }) => (`$${(parseFloat(row.original?.cantidad?.toString() || "1") || 1) * (parseFloat(row.original?.precioUnitario?.toString() || "0") || parseFloat(row.original.producto_data?.precios?.[0]?.precio || "0") || 0)}`) || '0',
      size: 100,
    }, */
    {
      accessorKey: 'accion',
      header: 'Acciones',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <Box sx={{ display: 'flex', gap: '1rem' }}>

            <Tooltip title="Eliminar">
              <IconButton
                onClick={() => {
                  removeSelectedItem(row.original.id!, key);
                }}
              >
                <DeleteIcon color="error" />
              </IconButton>
            </Tooltip>
          </Box>
        );
      }
    },
  ], []);

  const columnsItemMaterialesEquipos = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'producto_data.codigo',
      header: 'Codigo',
      Cell: ({ row }) => row.original.producto_data?.codigo ?? 'N/A',
      size: 100,
    },
    {
      accessorKey: 'producto_data.categoria_producto',
      header: 'Categoria',
      Cell: ({ row }) => row.original.producto_data?.categoria_producto ?? 'N/A',
      size: 150,
    },
    {
      accessorKey: 'producto_data.subcategoria_producto',
      header: 'SubCategoria',
      Cell: ({ row }) => row.original.producto_data?.subcategoria_producto ?? 'N/A',
      size: 150,
    },
    {
      accessorKey: 'descripcion',
      header: 'Descripción',
      Cell: ({ row }) => row.original?.descripcion || row.original.producto_data?.descripcion || 'N/A',
      size: 200,
    },
    {
      accessorKey: 'cantidad',
      header: 'Cantidad',
      size: 250,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <TextField
            variant="outlined"
            defaultValue={1}
            value={row.original.cantidad?.toString()}
            onChange={e => {

              onChangeQuantity(e.target.value, {
                ...row.original,
                id: row.original.id,
              });
            }}
            type="number"
            inputProps={{ min: 0, max: row.original.producto_data?.stock_actual, step: 1 }}
            sx={{
              width: '80%',
            }}
          />
        );
      }
    },
    {
      accessorKey: 'accion',
      header: 'Acciones',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <Box sx={{ display: 'flex', gap: '1rem' }}>

            <Tooltip title="Eliminar">
              <IconButton
                onClick={() => {
                  removeSelectedItem(row.original.id!, key);
                }}
              >
                <DeleteIcon color="error" />
              </IconButton>
            </Tooltip>
          </Box>
        );
      }
    },

  ], []);


  const columnsItemServiciosDigitales = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'nombre',
      header: 'Nombre',
      Cell: ({ row }) => row.original.nombre ?? 'N/A',
      // size: 100,
    },
    {
      accessorKey: 'producto_data.categoria_producto',
      header: 'Categoria',
      Cell: ({ row }) => row.original.producto_data?.categoria_producto ?? 'N/A',
      size: 150,
    },
    {
      accessorKey: 'descripcion',
      header: 'Descripción',
      Cell: ({ row }) => row.original?.descripcion || row.original.producto_data?.descripcion || 'N/A',
      size: 250,
    },
    {
      accessorKey: 'cantidad',
      header: 'Cantidad',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <TextField
            variant="outlined"
            defaultValue={1}
            value={row.original.cantidad?.toString()}
            onChange={e => {

              onChangeQuantity(e.target.value, {
                ...row.original,
                id: row.original.id,
              });
            }}
            type="number"
            inputProps={{ min: 0, max: row.original.producto_data?.stock_actual, step: 1 }}
          />
        );
      }
    },
    {
      accessorKey: 'accion',
      header: 'Acciones',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <Box sx={{ display: 'flex', gap: '1rem' }}>

            <Tooltip title="Eliminar">
              <IconButton
                onClick={() => {
                  removeSelectedItem(row.original.id!, key);
                }}
              >
                <DeleteIcon color="error" />
              </IconButton>
            </Tooltip>
          </Box>
        );
      }
    },
  ], []);

  const columnsItemFactibilidadCorporativaNoEdit = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'producto_data.codigo',
      header: 'Codigo',
      size: 100,
    },
    {
      accessorKey: 'producto_data.categoria_producto',
      header: 'Categoria',
      size: 150,
    },
    {
      accessorKey: 'producto_data.subcategoria_producto',
      header: 'SubCategoria',
      size: 150,
    },
    {
      accessorKey: 'descripcion',
      header: 'Descripción',
      Cell: ({ row }) => row.original?.descripcion || row.original.producto_data?.descripcion || 'N/A',
      size: 250,
    },
    {
      accessorKey: 'cantidad',
      header: 'Cantidad',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      // Cell: ({ row }) => {
      //   return (
      //     <TextField
      //       variant="outlined"
      //       defaultValue={1}
      //       value={row.original.cantidad?.toString()}
      //       onChange={e => {

      //         onChangeQuantity(e.target.value, {
      //           ...row.original,
      //           id: row.original.id,
      //         });
      //       }}
      //       type="number"
      //       inputProps={{ min: 0, max: row.original.producto_data?.stock_actual, step: 1 }}
      //     />
      //   );
      // }
    },
  ], []);


  const columnsCrearFactibilidadCorporativa = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'producto_data.codigo',
      header: 'Codigo',
      size: 100,
    },
    {
      accessorKey: 'producto_data.categoria_producto',
      header: 'Categoria',
      size: 150,
    },
    {
      accessorKey: 'producto_data.descripcion',
      header: 'Descripción',
      size: 150,
    },
    {
      accessorKey: 'accion',
      header: 'Acciones',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <Box sx={{ display: 'flex', gap: '1rem' }}>

            <Tooltip title="Eliminar">
              <IconButton
                onClick={() => {
                  removeSelectedItem(row.original.id!, key);
                }}
              >
                <DeleteIcon color="error" />
              </IconButton>
            </Tooltip>
          </Box>
        );
      }
    },
  ], []);

  const columnsEquiposAdicionalesNoc = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'producto_data.codigo',
      header: 'Codigo',
      size: 150,
    },

    {
      accessorKey: 'cantidad',
      header: 'Cantidad',
      size: 100,
    },
    {
      accessorKey: 'producto_data.categoria_producto',
      header: 'Categoria',
      size: 150,
    },
    {
      accessorKey: 'producto_data.descripcion',
      header: 'Descripción',
      size: 150,
    },
  ], []);

  const columnsMaterialFactibilidadCorporativo = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'producto_data.codigo',
      header: 'Codigo',
      size: 100,
    },
    {
      accessorKey: 'producto_data.categoria_producto',
      header: 'Categoria',
      size: 150,
    },
    {
      accessorKey: 'producto_data.subcategoria_producto',
      header: 'SubCategoria',
      size: 150,
    },
    {
      accessorKey: 'descripcion',
      header: 'Descripción',
      Cell: ({ row }) => row.original?.descripcion || row.original.producto_data?.descripcion || 'N/A',
      size: 250,
    },
    {
      accessorKey: 'cantidad',
      header: 'Cantidad',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <TextField
            variant="outlined"
            defaultValue={1}
            value={row.original.cantidad?.toString()}
            onChange={e => {

              if (!(+e.target.value <= +row.original.producto_data?.stock_actual!))
                return setAlert(true, texto.limite_stock_actual, AlertSeverityEnum.warning);

              onChangeQuantity(e.target.value, {
                ...row.original,
                id: row.original.id,
              });
            }}
            type="number"
            inputProps={{ min: 0, max: row.original.producto_data?.stock_actual, step: 1 }}
          />
        );
      }
    }
  ], []);

  const columnsMaterialRevisarFactibilidadCorporativo = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'existe',
      header: 'Existe',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <Checkbox
            //value={row.original.existe}
            defaultChecked={false || row.original.existe}
            onChange={e => {
              onChangeExisteInventariable(e.target.checked, {
                ...row.original,
                id: row.original.id,
              });
            }}
          />
        );
      },
    },
    {
      accessorKey: 'codigo',
      header: 'Codigo',
      size: 150,
    },
    {
      accessorKey: 'cantidad',
      header: 'Cantidad',
      size: 100,
    },
    {
      accessorKey: 'stock_actual',
      header: 'stock actual',
      size: 150,
    },
    {
      accessorKey: 'categoria_fcorporativa',
      header: 'Categoria',
      size: 150,
      Cell: ({ row }) => row.original.producto_data?.categoria_producto || "N/A"
    },
    {
      accessorKey: 'categoria_fcorporativa',
      header: 'solicitado por',
      size: 150,
      Cell: ({ row }) =>
        row.original.categoria_fcorporativa == CategoriaFCorporativaEnum.EQUIPOSADICIONALES ?
          "CLIENTE"
          : row.original.categoria_fcorporativa == CategoriaFCorporativaEnum.MATERIALESEQUIPOS ?
            "NOC"
            : "N/A"
    },
    {
      accessorKey: 'descripcion',
      header: 'Descripción',
      Cell: ({ row }) => row.original?.descripcion || row.original.producto_data?.descripcion || 'N/A',
      size: 250,
    },
    {
      accessorKey: 'nombre',
      header: 'Nombre',
      size: 150,
      Cell: ({ row }) => row.original.nombre || "N/A"
    },
  ], []);


  const columnsMaterialAgendamientoNoc = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'accion',
      header: 'Acciones',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <Box sx={{ display: 'flex', gap: '1rem' }}>

            <Tooltip title="Eliminar">
              <IconButton
                onClick={() => {
                  removeSelectedItem(row.original.id!, key);
                }}
              >
                <DeleteIcon color="error" />
              </IconButton>
            </Tooltip>
          </Box>
        );
      }
    },
    {
      accessorKey: 'codigo',
      header: 'Codigo',
      size: 150,
    },
    {
      accessorKey: 'cantidad',
      header: 'Cantidad',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <TextField
            variant="outlined"
            defaultValue={1}
            value={row.original.cantidad?.toString()}
            onChange={e => {

              if (!(+e.target.value <= +row.original.stock_actual!))
                return setAlert(true, texto.limite_stock_actual, AlertSeverityEnum.warning);

              onChangeQuantity(e.target.value, {
                ...row.original,
                id: row.original.id,
              });
            }}
            type="number"
            inputProps={{ min: 0, max: row.original.producto_data?.stock_actual, step: 1 }}
          />

        );
      }
    },
    {
      accessorKey: 'stock_actual',
      header: 'stock actual',
      size: 150,
    },
    {
      accessorKey: 'categoria_fcorporativa',
      header: 'Categoria',
      size: 150,
    },
    {
      accessorKey: 'nombre',
      header: 'Descripción',
      size: 150,
    },
  ], []);

  const columnsMaterialEquiposNoc = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'codigo',
      header: 'Codigo',
      size: 150,
    },
    {
      accessorKey: 'cantidad',
      header: 'Cantidad',
      size: 100,
    },
    {
      accessorKey: 'categoria_fcorporativa',
      header: 'Categoria',
      size: 150,
    },
    {
      accessorKey: 'nombre',
      header: 'Descripción',
      size: 150,
    },
  ], []);

  const columnsTrasladoInventario = useMemo<
    MRT_ColumnDef<MaterialTransferido>[]
  >(
    () => [
      /* {
        accessorKey: 'contiene_series',
        header: 'Contiene series',
        size: 100,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return (
            <Checkbox
              defaultChecked={false || row.original.contiene_serie}
              onChange={e => {
                onChangeSeries(e.target.checked, {
                  ...row.original,
                  id: row.original.id,
                });
              }}
            />
          );
        },
      }, */
      {
        accessorKey: 'series',
        header: 'Series',
        size: 100,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {

          const original = row.original

          const {
            contiene_serie,
          } = original

          return (
            <ButtonSeries
              disabled={!contiene_serie}
              onClick={() => {
                handleCargarSeries && handleCargarSeries(row.original)
              }}
            />
          )
        },
      },
      {
        accessorKey: 'cantidad',
        header: 'CANT. SOLICITADA',
        size: 150,
      },
      {
        accessorKey: 'producto_data.codigo',
        header: 'Codigo',
        size: 100,
      },
      {
        accessorKey: 'producto_data.categoria_producto',
        header: 'Categoria',
        size: 150,
      },
      {
        accessorKey: 'producto_data.subcategoria_producto',
        header: 'SubCategoria',
        size: 150,
        Cell: ({ row }) => row.original.producto_data?.subcategoria_producto ?? 'N/A'

      },
      {
        accessorKey: 'producto_data.descripcion',
        header: 'Descripción',
        size: 150,
      },
    ],
    []
  );

  const columnsCrearTrasladoInventario = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [

    {
      accessorKey: 'accion',
      header: 'Acciones',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <Box sx={{ display: 'flex', gap: '1rem' }}>

            <Tooltip title="Eliminar">
              <IconButton
                onClick={() => {
                  removeSelectedItem(row.original.id!, MaterialesKey.selectItemsProductoTransferencia);
                }}
              >
                <DeleteIcon color="error" />
              </IconButton>
            </Tooltip>
          </Box>
        );
      }
    },
    {
      accessorKey: 'cantidad',
      header: 'Cantidad',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <TextField
            variant="outlined"
            defaultValue={1}
            value={row.original.cantidad?.toString()}
            onChange={e => {

              if (!(+e.target.value <= +row.original.producto_data?.stock_actual!))
                return setAlert(true, texto.limite_stock_actual, AlertSeverityEnum.warning);

              onChangeQuantity(e.target.value, {
                ...row.original,
                id: row.original.id,
              });
            }}
            type="number"
            inputProps={{ min: 0, max: row.original.producto_data?.stock_actual, step: 1 }}
          />

        );
      }
    },
    /* {
      accessorKey: 'contiene_series',
      header: 'Contiene series',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return row.original.cantidad! === 0 ? (
          <BlockIcon color="error" />
        ) : (
          <Checkbox
            value={row.original.contiene_serie}
            inputProps={{ 'aria-label': 'controlled' }}
            defaultChecked={false || row.original.contiene_serie}
            onChange={e => {
              onChangeSeries(e.target.checked, {
                ...row.original,
                id: row.original.id,
              });
            }
            }
          />
        )
      }
    }, */
    {
      accessorKey: 'series',
      header: 'Series',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {

        const original = row.original

        const {
          contiene_serie
        } = original
        return (
          <ButtonSeries
            disabled={!contiene_serie}
            onClick={() => {
              handleCargarSeries && handleCargarSeries(row.original)

            }}
          />
        )
      }
    },
    {
      accessorKey: 'producto_data.codigo',
      header: 'Codigo',
      size: 150,
    },
    {
      accessorKey: 'producto_data.stock_actual',
      header: 'Stock Actual',
      size: 100,
    },
    {
      accessorKey: 'producto_data.categoria_producto',
      header: 'Categoria',
      size: 150,
    },
    {
      accessorKey: 'producto_data.subcategoria_producto',
      header: 'SubCategoria',
      size: 150,
      Cell: ({ row }) => row.original.producto_data?.subcategoria_producto ?? 'N/A'
    },
    {
      accessorKey: 'producto_data.descripcion',
      header: 'Descripción',
      size: 150,
    },




  ], []);


  const columnCreateKitInventario = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'producto_data.codigo',
      header: 'Codigo',
      size: 100,
    },
    {
      accessorKey: 'producto_data.categoria_producto',
      header: 'Categoria',
      size: 150,
    },
    {
      accessorKey: 'producto_data.subcategoria_producto',
      header: 'SubCategoria',
      size: 150,
      Cell: ({ row }) => row.original.producto_data?.subcategoria_producto ?? 'N/A'
    },
    {
      accessorKey: 'producto_data.descripcion',
      header: 'Descripción',
      size: 150,
    },
    {
      accessorKey: 'cantidad',
      header: 'Cantidad',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <TextField
            onKeyDown={(event) => {
              if (['e', 'E', '-', '.', ','].includes(event.key))
                event.preventDefault();

            }}
            variant="outlined"
            defaultValue={1}
            value={row.original.cantidad?.toString()}
            onChange={e => {
              let currentValue = e.target.value;
              onChangeQuantity(currentValue, {
                ...row.original,
                id: row.original.id,
              });
            }}
            type="number"
            inputProps={{ min: 0, step: 1 }}
          />
        );
      }
    },
    {
      accessorKey: 'accion',
      header: 'Acciones',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <Box sx={{ display: 'flex', gap: '1rem' }}>
            <Tooltip title="Eliminar">
              <IconButton
                onClick={() => {
                  removeSelectedItem(row.original.id!, MaterialesKey.selectItemKit);
                }}
              >
                <DeleteIcon color="error" />
              </IconButton>
            </Tooltip>
          </Box>
        );
      }
    },
  ], [])


  const columnsRevisionTransferenciaInventario = useMemo<
    MRT_ColumnDef<MaterialTransferido>[]
  >(
    () => [
      /* {
        accessorKey: 'contiene_series',
        header: 'Contiene series',
        size: 100,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return (
            <Checkbox
              disabled={true}
              defaultChecked={false || row.original.contiene_serie}
              onChange={e => {
                onChangeSeries(e.target.checked, {
                  ...row.original,
                  id: row.original.id,
                });
              }}
            />
          );
        },
      },
      {
        accessorKey: 'series',
        header: 'Series',
        size: 100,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return (
            <Box sx={{ display: 'flex', gap: '1rem' }}>
              <Tooltip title="Cargar Series">
                <IconButton
                  onClick={() => {
                    handleCargarSeries && handleCargarSeries(row.original)
                  }}
                >
                  <QrCode2Icon color="primary" />
                </IconButton>
              </Tooltip>
            </Box>
          );
        },
      }, */
      {
        accessorKey: 'producto_data.codigo',
        header: 'Codigo',
        size: 150,
      },
      {
        accessorKey: 'cantidad',
        header: 'CANT. SOLICITADA',
        size: 150,
      },
      {
        accessorKey: 'cantidad_recibida',
        header: 'CANT. RECIBIDA',
        size: 150,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return (
            <TextField
              onKeyDown={(event) => {
                if (['e', 'E', '-', '.', ','].includes(event.key)) {
                  event.preventDefault();
                }
              }}
              variant="outlined"
              defaultValue={1}
              value={row.original.cantidad_recibida?.toString()}
              onChange={e => {
                let currentValue = e.target.value;
                onChangeQuantityRecibida(currentValue, {
                  ...row.original,
                  id: row.original.id,
                });
              }}
              type="number"
              inputProps={{ min: 0, step: 1 }}
            />
          );
        }
      },

      {
        accessorKey: 'producto_data.categoria_producto',
        header: 'Categoria',
        size: 150,
      },
      {
        accessorKey: 'producto_data.subcategoria_producto',
        header: 'SubCategoria',
        size: 150,
        Cell: ({ row }) => row.original.producto_data?.subcategoria_producto ?? 'N/A'

      },
      /* {
        accessorKey: 'producto_data.descripcion',
        header: 'Descripción',
        size: 150,
      }, */
    ],
    []
  );









  const columnsItemServiciosDigitalesFactibilidad = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'nombre',
      header: 'Nombre',
      Cell: ({ row }) => row.original.nombre ?? 'N/A',
      // size: 100,
    },
    {
      accessorKey: 'producto_data.categoria_producto',
      header: 'Categoria',
      Cell: ({ row }) => row.original.producto_data?.categoria_producto ?? 'N/A',
      size: 150,
    },
    {
      accessorKey: 'descripcion',
      header: 'Descripción',
      Cell: ({ row }) => row.original?.descripcion || row.original.producto_data?.descripcion || 'N/A',
      size: 250,
    },
    {
      accessorKey: 'cantidad',
      header: 'Cantidad',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
    },
    {
      accessorKey: 'precios',
      header: 'Precios Referenciales',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      // row.original.producto_data?.precios?.map((precio) => precio.precio).join(', ') ?? 'N/A'
      Cell: ({ row }) => {
        return (
          <CustomAutocompleteArrStringNoForm
            label=""
            options={["N/A"].concat(row.original.producto_data?.precios?.map((precio) => precio.precio) || [])}
            defaultValue={row.original.producto_data?.precios?.[0]?.precio || row.original.precioUnitario}
            onChangeValue={value => {

              onChangePrecioUnitario(value, {
                ...row.original,
                id: row.original.id,
              });
            }}
          />
        );
      }
    },
    {
      accessorKey: 'precioUnitario',
      header: 'Precio Unitario',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <CustomTextFieldNoForm
            label=""
            variant="outlined"
            defaultValue={row.original.precioUnitario || 1}
            value={row.original.precioUnitario || row.original.producto_data?.precios?.[0]?.precio}
            onChangeCustom={e => {
              console.log(row.original)

              onChangePrecioUnitario(e.target.value, {
                ...row.original,
                id: row.original.id,
              });
            }}
            type="number"
          />
        );
      }
    },
    {
      accessorKey: 'precioTotal',
      header: 'Precio Total',
      Cell: ({ row }) => (`$${(parseFloat(row.original?.cantidad?.toString() || "1") || 1) * (parseFloat(row.original?.precioUnitario?.toString() || "0") || parseFloat(row.original.producto_data?.precios?.[0]?.precio || "0") || 0)}`) || '0',
      size: 100,
    },
    {
      accessorKey: 'accion',
      header: 'Acciones',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <Box sx={{ display: 'flex', gap: '1rem' }}>

            <Tooltip title="Eliminar">
              <IconButton
                onClick={() => {
                  removeSelectedItem(row.original.id!, key);
                }}
              >
                <DeleteIcon color="error" />
              </IconButton>
            </Tooltip>
          </Box>
        );
      }
    },
  ], []);

  return {
    columnsIngresoInventario,
    columnsTrasladoInventario,
    columnsCrearTrasladoInventario,
    columnsSolicitudTrasladoInventario,
    columnCreateKitInventario,
    columnsItemFactibilidadCorporativa,
    columnsItemFactibilidadCorporativaNoEdit,
    columnsMaterialRevisarFactibilidadCorporativo,
    columnsMaterialFactibilidadCorporativo,
    columnsCrearFactibilidadCorporativa,
    columnsEquiposAdicionalesNoc,
    columnsMaterialEquiposNoc,
    columnsMaterialAgendamientoNoc,
    columnsRevisionTransferenciaInventario,
    columnsItemFactibilidadCorporativaPendiente,
    columnsItemServiciosDigitales,
    columnsItemServiciosDigitalesFactibilidad,
    columnsItemMaterialesEquipos
  }
}